import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { AuthService } from './auth.service';


@Injectable()
export class TokenInterceptor implements HttpInterceptor
{
    constructor(private _authService: AuthService) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>
    {
        // List of public endpoints that should NOT have auth headers
        const publicEndpoints = [
            '/category/front',
            '/offer/front',
            '/category/',  // For category detail pages
            '/apps/subcategory/' // For app listing pages
        ];

        // Check if this is a public endpoint
        const isPublicEndpoint = publicEndpoints.some(endpoint => req.url.includes(endpoint));

        // Clone the request object
        let newReq = req.clone();

        // Only add auth header if NOT a public endpoint and token exists
        if (!isPublicEndpoint && this._authService.accessToken && !this._authService.isTokenExpired) {
            newReq = req.clone({
                headers: req.headers.set('Authorization', 'Bearer ' + this._authService.accessToken)
            });
        }

        // Response
        return next.handle(newReq).pipe(
            catchError((error) => {

                // Catch "401 Unauthorized" responses
                // BUT ONLY log out if it's NOT a public endpoint
                if ( error instanceof HttpErrorResponse && error.status === 401 ) {
                    // Don't log out for public endpoint errors
                    if (!isPublicEndpoint) {
                        // Sign out
                        this._authService.signOut();
                        this._authService.clearLocalStorage();

                        // Reload the app
                        location.reload();
                    }
                }

                return throwError(() => error);
            })
        );
    }
}
